import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class ClientEffects {



  constructor(private actions$: Actions) {}

}
